export const NAV_DISPLAY_CONFIG_OVERLAY_OPEN_MESSAGE = 'NAV_DISPLAY_CONFIG_OVERLAY_OPEN_MESSAGE';
export const NAV_DISPLAY_CONFIG_OVERLAY_CLOSE_MESSAGE = 'NAV_DISPLAY_CONFIG_OVERLAY_CLOSE_MESSAGE';
export const NAV_DISPLAY_CONFIG_MODAL_OVERLAY_TYPE = 'UIModal';